export class Feedback {
  type: FeedbackType;
  message: string;
}

export enum FeedbackType {
  Success,
  Error
}
